// 261023 E3-P3kc — KHÔI PHỤC từ `868a7d0` (User 26/10 «cột bước bên trái rõ hơn»); thêm badge «N gợi ý» ở ⑤ (prop `hints`, quyết định ở `stageNavView.hintBadgeOf`).
// 261005 E1-P1 / E5 — danh sách 5 BƯỚC ở thanh trái. 261023 E3-P3h1 (H4/K4/K7): mỗi bước nói «✓ xong · đang chạy… · chưa chạy · Chặng n · cần bạn · x/y xong» + thanh tiến độ mảnh.
// Quyết định ở `stageNavView.ts` (hàm thuần, có jest); file này chỉ vẽ. Bước chưa tới vẫn bấm được để XEM.
import React from 'react';
import { Tooltip } from 'antd';
import type { WorkbenchStageKey } from '../../../types/adaptationWorkbench';
import { STAGE_LABEL } from './workbenchView';
import { hintBadgeOf, StageNavRow } from './stageNavView';
import { Pill } from './WbSlot';

/** 261023 E3-P3a — hàng «Sổ duyệt» trên 5 bước (chỉ hiện khi `visible`). */
export interface ReviewEntry { visible: boolean; active: boolean; needCount: number; onOpen: () => void }

interface Props {
  /** 5 hàng đã tính (`stageNavRows`); `null` khi chưa tải workbench. */
  rows: StageNavRow[] | null;
  /** `null` khi đang ở Sổ duyệt (không bước nào được tô). */
  current: WorkbenchStageKey | null;
  review?: ReviewEntry;
  onSelect: (k: WorkbenchStageKey) => void;
  /** 3k-c — «N gợi ý» của Sổ duyệt (`reviewEntryView.hintCount`): badge nhỏ trên mục ⑤. */
  hints?: number;
}

const numTone = (r: StageNavRow, cur: boolean): string => {
  if (cur) return 'cur';
  if (r.status === 'locked') return 'lock';
  if (r.done) return 'ok';
  if (r.needYou) return 'warn';
  return 'todo';
};

const StageNav: React.FC<Props> = ({ rows, current, onSelect, review, hints }) => (
  <nav className="wb-stages" aria-label="Các bước chuyển thể" data-tour="nav">
    {review?.visible && (
      <Tooltip placement="right" title="Một bảng cả truyện: tập nào cần bạn xem, tập nào máy đã lo. Số «cần bạn» ở đây chưa gồm tên gốc rò — số đủ nằm trong Sổ.">
        <button type="button" className={`wb-stage-btn wb-nv wb-rb-entry${review.needCount > 0 ? ' wb-nv-need' : ''}`} aria-current={review.active ? 'true' : undefined} onClick={review.onOpen}>
          <span className="wb-nv-r1">
            <span className={`wb-num wb-num-${review.active ? 'cur' : 'todo'}`}>≡</span>
            <span className="wb-sn">Sổ duyệt</span>
            {review.needCount > 0 && <span className="wb-nv-tag">cần bạn</span>}
          </span>
          <span className="wb-nv-xy">
            {review.needCount > 0 ? <><b>{review.needCount}</b> việc còn cần bạn</> : 'không còn việc cần xem'}
          </span>
        </button>
      </Tooltip>
    )}
    {(rows ?? []).map((r, idx) => {
      const cur = current === r.key;
      const hint = hintBadgeOf(r.key, hints);
      const quiet = r.done && !cur && !r.needYou;
      const cls = ['wb-stage-btn', 'wb-nv', r.status === 'locked' ? 'wb-locked-btn' : '', r.needYou ? 'wb-nv-need' : '', quiet ? 'wb-nv-quiet' : '', r.status === 'notRun' ? 'wb-nv-notrun' : ''].filter(Boolean).join(' ');
      return (
        <Tooltip key={r.key} placement="right" title={[r.tip ? `${STAGE_LABEL[r.key]} — ${r.tip}` : STAGE_LABEL[r.key], hint?.title].filter(Boolean).join(' · ')}>
          <button type="button" className={cls} aria-current={cur ? 'true' : undefined} onClick={() => onSelect(r.key)} data-step={idx + 1}>
            <span className="wb-nv-r1">
              <span className={`wb-num wb-num-${numTone(r, cur)}`}>{cur && r.done ? idx + 1 : r.glyph}</span>
              <span className="wb-sn">{STAGE_LABEL[r.key]}</span>
              {hint && <span className="wb-nv-hint" title={hint.title}>{hint.label}</span>}
              {r.needYou ? <span className="wb-nv-tag">{r.needTag}</span> : r.dot ? <Pill tone={r.dot === 'bad' ? 'bad' : 'warn'}>{r.dotText || '!'}</Pill> : null}
            </span>
            {r.label && <span className="wb-nv-xy">{r.status === 'running' && <span className="wb-nv-spin" aria-hidden="true" />}{r.label}</span>}
            {r.pct !== null && <span className="wb-nv-bar" aria-hidden="true"><i style={{ width: `${r.pct}%` }} /></span>}
          </button>
        </Tooltip>
      );
    })}
  </nav>
);

export default StageNav;
